import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import bg from '../../assets/images/cases_feed_item_bg.png';

const StyledBg = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	mask-image: url(${bg});
	mask-size: cover;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${bg});
	-webkit-mask-size: cover;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
`;

const StyledPoint = styled.svg`
	position: absolute;
	top: 10px;
	left: 10px;
	transition: opacity 0.3s ease;
`;

const StyledTitle = styled(Text)`
	position: absolute;
	top: 87px;
	left: 50%;
	width: 100%;
	transform: translateX(-50%);
	font-weight: 500;
	font-size: 14px;
	text-align: center;
	color: #ffffff;
	transition: top 0.3s ease;
`;

const StyledImageContainer = styled.div`
	position: absolute;
	top: 20px;
	left: 50%;
	transform: translateX(-50%);
	transition: opacity 0.3s ease;

	img,
	.collection-spinner > div {
		height: 56px !important;
	}
`;

const StyledExpContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	height: 56px;
	color: #ffffff;
`;

const StyledButtonContainer = styled.div`
	position: absolute;
	left: 20px;
	bottom: 20px;
	right: 20px;
	transition: opacity 0.3s ease;
	opacity: 0;

	button {
		font-size: 16px;
		border-radius: 5px;
	}
`;

const StyledContainer = styled.div`
	position: relative;
	width: 180px;
	min-width: 180px;
	height: 120px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	transition: border 0.3s ease;

	&:hover {
		border: 1px solid rgba(255, 255, 255, 1);

		${StyledPoint} {
			opacity: 0;
		}

		${StyledTitle} {
			top: 17px;
		}

		${StyledImageContainer} {
			opacity: 0;
		}

		${StyledButtonContainer} {
			opacity: 1;
		}
	}
`;

export {
	StyledBg,
	StyledButtonContainer,
	StyledContainer,
	StyledExpContainer,
	StyledImageContainer,
	StyledPoint,
	StyledTitle,
};
